import { render, staticRenderFns } from "./PerformanceReportTablesPage.vue?vue&type=template&id=cc678896&scoped=true"
import script from "./PerformanceReportTablesPage.vue?vue&type=script&lang=js"
export * from "./PerformanceReportTablesPage.vue?vue&type=script&lang=js"
import style0 from "./PerformanceReportTablesPage.vue?vue&type=style&index=0&id=cc678896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc678896",
  null
  
)

export default component.exports